import { render, staticRenderFns } from "./Gaau.vue?vue&type=template&id=e8ec0774&"
import script from "./Gaau.vue?vue&type=script&lang=js&"
export * from "./Gaau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports